import { loadMetaData } from "../../../_metadata/EntityPropertyMap";

let init = false;

export function loadEntityPropertyMap() {
	if (init) {
		return;
	}
	init = true;
	loadMetaData();
}
